export enum ExposureRiskEnum {
    Low = 0,
    Medium = 1,
    High = 2,
    VeryHigh = 3
}